/* ms4l gallery mechanics, 20.10.2026 (v2-scope). Loaded (defer) only with the theme flag ms4l_gallery_v2.
   The Flickity options and the scroll guard live in assets/product.js (ms4lGalleryGuard); the 1:1 frame in
   assets/ms4l-gallery-v2.css. This file only:
   1) paints the side (or top/bottom) areas of a non-square photo in that photo's own edge colours, so the frame
      does not show white or grey strips next to a photo with a light-grey background (phones only);
   2) sends gallery_swipe through window.MS4L_ETA.track (GA4 + Clarity) when the visitor changes the slide.
   reports/slider_oct20/30-dev-changelog.md (v2-scope). */
(function () {
  'use strict';
  var el = document.getElementById('Product-Slider');
  if (!el || !el.classList.contains('ms4l-gv2')) return;
  var mq = window.matchMedia('(max-width: 767px)');

  /* ---------- 1) letterbox in the photo's own edge colour ---------- */
  function rgb(c) { return 'rgb(' + Math.round(c[0]) + ',' + Math.round(c[1]) + ',' + Math.round(c[2]) + ')'; }
  function mean(d, idx) {
    var s = [0, 0, 0];
    idx.forEach(function (i) { s[0] += d[i]; s[1] += d[i + 1]; s[2] += d[i + 2]; });
    return [s[0] / idx.length, s[1] / idx.length, s[2] / idx.length];
  }
  function tint(img) {
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) return;
    var ar = nw / nh;
    if (Math.abs(ar - 1) < 0.005) return;                 /* square: no side areas */
    var box = img.parentNode;
    try {
      var W = ar < 1 ? 24 : 48, H = Math.max(2, Math.round(W / ar));
      var c = document.createElement('canvas');
      c.width = W; c.height = H;
      var x = c.getContext('2d');
      x.drawImage(img, 0, 0, W, H);
      var d = x.getImageData(0, 0, W, H).data, a = [], b = [], i;
      if (ar < 1) {                                        /* tall: left and right areas */
        for (i = 0; i < H; i++) { a.push((i * W) * 4); b.push((i * W + W - 1) * 4); }
        box.style.background = 'linear-gradient(to right,' + rgb(mean(d, a)) + ' 0 50%,' + rgb(mean(d, b)) + ' 50% 100%)';
      } else {                                             /* wide: top and bottom areas */
        for (i = 0; i < W; i++) { a.push(i * 4); b.push(((H - 1) * W + i) * 4); }
        box.style.background = 'linear-gradient(to bottom,' + rgb(mean(d, a)) + ' 0 50%,' + rgb(mean(d, b)) + ' 50% 100%)';
      }
    } catch (e) { /* cross-origin image or no canvas: keep the white frame */ }
  }
  function tintAll() {
    if (!mq.matches) return;
    el.querySelectorAll('.product-single__media-image > img').forEach(function (img) {
      if (img.complete && img.naturalWidth) tint(img);
      else img.addEventListener('load', function () { tint(img); }, { once: true });
    });
  }
  (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(tintAll);

  /* ---------- 2) gallery_swipe ---------- */
  var queue = [], waits = 0;
  function flush() {
    if (!(window.MS4L_ETA && MS4L_ETA.track)) { if (queue.length && ++waits < 60) setTimeout(flush, 500); return; }
    while (queue.length) { var e = queue.shift(); try { MS4L_ETA.track(e[0], e[1]); } catch (x) {} }
  }
  function track(name, p) {
    var t = window.Shopify && Shopify.theme;
    if (!t || t.role !== 'main') { p.debug_mode = true; p.theme = 'test'; }
    p.device = mq.matches ? 'mobile' : 'desktop';
    queue.push([name, p]); flush();
  }
  var n = 0;
  (function ready() {
    var f = window.Flickity && Flickity.data(el);
    if (!f || !f.cells) { if (++n < 200) setTimeout(ready, 50); return; }
    var how = 'program', last = f.selectedIndex;
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#Product-Thumbnails .product-thumbnail, #Product-Slider .flickity-nav, #Product-Slider .flickity-page-dots')) how = 'tap';
    }, true);
    f.on('dragEnd', function () { how = 'swipe'; });
    f.on('change', function (i) {
      if (how !== 'program') {
        var m = f.cells[i] && f.cells[i].element.querySelector('.product-single__media');
        track('gallery_swipe', { from_index: last + 1, to_index: i + 1, slides: f.cells.length, method: how,
          media: m && /video/.test(m.className) ? 'video' : 'image' });
      }
      last = i; how = 'program';
    });
  })();
})();
